<div
  class="nav-tabs-container px-2 px-md-3 position-relative widthContainer"
  *ngIf="showCondition && menuCategories && menuCategories.length > 0"
  [ngClass]="{
    'd-none': menuCategories && menuCategories.length <= 0,
    'padding-left': !navMaxLeftScroll[wrapperId] ? '0' : 'initial',
    padding: !navMaxRightScroll[wrapperId] || !navMaxLeftScroll[wrapperId],
  }"
>
  <i
    class="fas fa-chevron-left d-flex text-secondary chevron-left position-absolute theme-color-secondary-text"
    [ngClass]="{ chevroncolor: !navMaxLeftScroll[wrapperId] }"
    (click)="scrollNavToLeft(wrapperId)"
    *ngIf="!navMaxRightScroll[wrapperId] || !navMaxLeftScroll[wrapperId]"
  ></i>
  <div class="w-100 py-2 nav-tabs-container" [id]="wrapperId">
    <ul class="nav nav-tabs d-inline-flex ml-0 ml-md-2 mr-3" role="tablist">
      <li
        *ngFor="let catItem of menuCategories; let first = first"
        [ngClass]="{ firstItem: first }"
        role="presentation"
        class="catalog_category_li mx-0 mx-md-2 position-relative text-unselectable"
        [class.active]="selectedCat === catItem.categoryId"
        id="tab{{ catItem.categoryId }}"
      >
        <a
          (click)="onSelectCategory(catItem.categoryId)"
          aria-controls="one"
          role="tab"
          data-toggle="tab"
          class="font-size-primary py-2 px-2 px-md-3 rounded font-weight-bold theme-color-header theme-light"
          [ngClass]="{
            'font-weight-bold': selectedCat === catItem.categoryId,
            'theme-color-header': selectedCat === catItem.categoryId,
            'theme-light': selectedCat === catItem.categoryId,
          }"
        >
          {{ catItem.name }}
        </a>
      </li>
    </ul>
  </div>
  <i
    class="fas fa-chevron-right text-secondary d-flex chevron-right position-absolute theme-color-secondary-text"
    [ngClass]="{ chevroncolor: !navMaxRightScroll[wrapperId] }"
    (click)="scrollNavToRight(wrapperId)"
    *ngIf="!navMaxLeftScroll[wrapperId] || !navMaxRightScroll[wrapperId]"
  ></i>
</div>
